import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CloseIcon} from '../../../components/icons'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'
import Button from '/overrides/app/components/button'

const SwitchSiteConfirmationDialog = ({isOpen, onConfirm, onClose}) => {
    const cancelRef = useRef()
    const {tShipping} = useTranslationHelpers()

    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay alignItems="center">
                <AlertDialogContent maxW={{base: '95vw', md: '720px'}}>
                    <Button variant="closeIcon" ref={cancelRef} onClick={onClose}>
                        <CloseIcon height="15px" width="15px" />
                    </Button>
                    <AlertDialogHeader fontSize="2xl" fontWeight="bold" paddingTop="54px">
                        {tShipping?.modalTitle}
                    </AlertDialogHeader>

                    <AlertDialogBody>{tShipping?.modalText}</AlertDialogBody>

                    <AlertDialogFooter
                        paddingBottom="45px"
                        display="flex"
                        flexDirection={{base: 'column', md: 'row'}}
                        gap={{base: '25px', md: '0'}}
                        alignItems="center"
                    >
                        <Button
                            ref={cancelRef}
                            variant="primary"
                            onClick={onClose}
                            width={{base: '100%', md: 'auto'}}
                        >
                            {tShipping?.modalButtonCancel}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={onConfirm}
                            ml={{base: 0, md: 3}}
                            width={{base: '100%', md: 'auto'}}
                        >
                            {tShipping?.buttonConfirm}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

SwitchSiteConfirmationDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func
}

export default SwitchSiteConfirmationDialog
